import { bindFeePolicy, type FeeAuthorization, type V2Coin } from "./action";
import type { V2ContractConfig } from "./client";

export type ActionFeePolicy = Readonly<{
  authorization: FeeAuthorization;
  collector: string;
}>;

/** Snapshot attested contract terms; never invent an upgrade for a legacy deployment. */
export const actionFeePolicy = (
  config: V2ContractConfig,
  protocolFees?: readonly Readonly<V2Coin>[]
): ActionFeePolicy | undefined => {
  const strict = config.fee_rules != null;
  if (strict && (!(Number(config.fee_policy_version) > 0) || !protocolFees))
    throw new Error("Exact protocol fee authorization is required");
  if (config.fee_policy_version === undefined) return undefined;
  const authorization = Object.freeze({
    policy_version: config.fee_policy_version,
    protocol_fee_bps: config.protocol_fee_bps,
    ...(strict && {
      protocol_fees: Object.freeze(
        protocolFees!.map((coin) => Object.freeze({ ...coin }))
      ),
    }),
  });
  // Validate even when invoked with a mocked or external config provider.
  bindFeePolicy(new Uint8Array(), authorization, config.fee_collector);
  return Object.freeze({ authorization, collector: config.fee_collector });
};

export const authorizedFeePayload = (
  payload: Uint8Array,
  policy: ActionFeePolicy | undefined
): Uint8Array =>
  policy
    ? bindFeePolicy(payload, policy.authorization, policy.collector)
    : payload;
